module.exports = __webpack_public_path__ + "static/media/Hurtigbenevning-instruction-nr-2.90da0f93.mp3";